import React, { useState } from "react";
import styles from './newsix.module.css';
import jobIcon from '../../../src/assets/images/icon/jobicon.svg';
import dbIcon from '../../../src/assets/images/icon/db-icon.svg';
import DaysIcon from '../../../src/assets/images/icon/days-icon.svg';
import AudienceIcon from '../../../src/assets/images/icon/audience-icon.svg';
import ClockIcon from '../../../src/assets/images/icon/clock-icon.svg';
import Whatsapp from '../../../src/assets/images/icon/whatsapp.svg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCheckCircle, faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

const Newsix = () => {
  const [activeTab, setActiveTab] = useState("jobPostPlans");
  return (
    <div>
        <div className="container-fluid">
          <div className="row my-3 justify-content-center">
              <div className="col-md-6 text-center">
                  <h1 className={`${styles['jobplan-title']} text-info`}>post a job</h1>
                  <p className={`${styles['jobplan-paragraph']} mb-4`}>quick & easy job posting - get quality applies</p>
              </div>
          </div>
          <div className="row">
              <div className="col-md-12">
                {/* Tabs Header */}
      <ul className='nav nav-pills mb-4 justify-content-center border-0'>
        <li className="nav-item">
          <button
            className={`nav-search nav-link ${activeTab === "jobPostPlans" ? "active" : ""}`}
            onClick={() => setActiveTab("jobPostPlans")}
          >
            Job Post Plans
          </button>
        </li>
        <li className="nav-item mx-2">
          <button
            className={`nav-search nav-link ${activeTab === "databasePlan" ? "active" : ""}`}
            onClick={() => setActiveTab("databasePlan")}
          >
            Database Plans
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-search nav-link ${activeTab === "customPlan" ? "active" : ""}`}
            onClick={() => setActiveTab("customPlan")}
          >
            Custom Plan
          </button>
        </li>
      </ul>

      {/* Tab Content */}
      <div>
        {activeTab === "jobPostPlans" && (
          <div className="row justify-content-center">
            {/* Job Post Plans */}
            <div className="col-md mb-4">
                <div className={`${styles['jobplan-box']}`}>
                  <div className={`${styles['jobbox-top']}`}>
                      <h3>Basic Plan</h3>
                      <p>Basic Job Posting</p>
                      <img src={jobIcon} className={`${styles['job-image']} img-fluid`}/>
                  </div>
                  <div className={`${styles['jobbox-cost']} my-3 p-2`}>
                      <h4>&#8377; 35000/<span>Year</span></h4>
                      <a href="#" className={`${styles['subs-btn']} btn w-100 mt-3`}> Subscribed</a>
                  </div>
                  <div className={`${styles['jobbox-list']} p-2`}>
                      <ul>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Free 5 Regular Job Posting</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Vaild for all Cities</li>
                      </ul>
                  </div>
                </div>
            </div>
            <div className="col-md mb-4">
                <div className={`${styles['jobplan-box']}`}>
                  <div className={`${styles['jobbox-top']}`}>
                      <h3>Sliver Package</h3>
                      <p>Sliver Job Posting</p>
                      <img src={jobIcon} className={`${styles['job-image']} img-fluid`}/>
                  </div>
                  <div className={`${styles['jobbox-cost']} my-3 p-2`}>
                      <h4>&#8377; 35000/<span>Year</span></h4>
                      <a href="#" className={`${styles['subs-btn']} btn w-100 mt-3`}> Subscribed</a>
                  </div>
                  <div className={`${styles['jobbox-list']} p-2`}>
                      <ul>
                      <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>7 Featured Job Posting</li>
                      <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>3 Video Job Descriptions</li>
                      <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Valid for all Cities</li>
                      <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Auto Boost on Job Search</li>
                      <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Automatic Sharing on Social Media</li>
                      </ul>
                  </div>
                </div>
            </div>
            <div className="col-md mb-4">
                <div className={`${styles['jobplan-box']}`}>
                  <div className={`${styles['jobbox-top']}`}>
                      <h3>Gold Package</h3>
                      <p>Gold Job Posting</p>
                      <img src={jobIcon} className={`${styles['job-image']} img-fluid`}/>
                  </div>
                  <div className={`${styles['jobbox-cost']} my-3 p-2`}>
                      <h4>&#8377; 80,000/<span>Year</span></h4>
                      <a href="#" className={`${styles['subs-btn']} btn w-100 mt-3`}> Subscribed</a>
                  </div>
                  <div className={`${styles['jobbox-list']} p-2`}>
                      <ul>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>1000 Featured Job Posting</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>10 Video Job Descriptions</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Valid for all Cities</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Auto Boost on Job Search</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Free ATS</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Ad Banner for 1 Month</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Automatic Sharing on Social Media</li>
                      </ul>
                  </div>
                </div>
            </div>
            <div className="col-md mb-4">
                <div className={`${styles['jobplan-box']}`}>
                  <div className={`${styles['jobbox-top']}`}>
                      <h3>Platinum Package</h3>
                      <p>Platinum Job Posting</p>
                      <img src={jobIcon} className={`${styles['job-image']} img-fluid`}/>
                  </div>
                  <div className={`${styles['jobbox-cost']} my-3 p-2`}>
                      <h4>&#8377; 1,20,000/<span>Year</span></h4>
                      <a href="#" className={`${styles['subs-btn']} btn w-100 mt-3`}> Subscribed</a>
                  </div>
                  <div className={`${styles['jobbox-list']} p-2`}>
                      <ul>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>10000 Featured Job Posting</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>50 Video Job Descriptions</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Valid for all Cities</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Auto Boost on Job Search</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Free ATS</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Ad Banner for 1 Month</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Microsite</li>
                        <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Automatic Sharing on Social Media</li>
                      </ul>
                  </div>
                </div>
            </div>
            {/* Add other Job Post Plan cards here */}
          </div>
        )}

        {activeTab === "databasePlan" && (
          <div className="row justify-content-center">
          {/* Job Post Plans */}
          <div className="col-md mb-4">
              <div className={`${styles['jobplan-box']}`}>
                <div className={`${styles['jobbox-top']}`}>
                    <h3>1 Month</h3>
                    <p>Ideal for small teams</p>
                    <img src={dbIcon} className={`${styles['job-image']} img-fluid`}/>
                </div>
                <div className={`${styles['jobbox-cost']} my-3 p-2`}>
                    <div className="d-flex flex-column align-items-start">
                      <div className="me-3">
                        <span className={`${styles['original-price']}`}>₹2800</span>
                      </div>
                      <div className="me-3">
                        <span className={`${styles['discounted-price']} pe-2`}>₹1689</span>
                        <span className={`${styles['discount']} border-start ps-2`}>10% Off</span>
                      </div>
                    </div>
                    <a href="#" className={`${styles['subs-btn']} btn w-100 mt-3`}> Subscribe Now</a>
                </div>
                <div className={`${styles['jobbox-list']} p-2`}>
                    <ul>
                      <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>200 Database credits</li>
                      <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Use these credits in 30 days</li>
                    </ul>
                </div>
              </div>
          </div>
          <div className="col-md mb-4">
              <div className={`${styles['jobplan-box']}`}>
                <div className={`${styles['jobbox-top']}`}>
                    <h3>1 Month</h3>
                    <p>Ideal for med-size businesses</p>
                    <img src={dbIcon} className={`${styles['job-image']} img-fluid`}/>
                </div>
                <div className={`${styles['jobbox-cost']} my-3 p-2`}>
                <div className="d-flex flex-column align-items-start">
                      <div className="me-3">
                        <span className={`${styles['original-price']}`}>₹2800</span>
                      </div>
                      <div className="me-3">
                        <span className={`${styles['discounted-price']} pe-2`}>₹1689</span>
                        <span className={`${styles['discount']} border-start ps-2`}>10% Off</span>
                      </div>
                    </div>
                    <a href="#" className={`${styles['subs-btn']} btn w-100 mt-3`}> Subscribe Now</a>
                </div>
                <div className={`${styles['jobbox-list']} p-2`}>
                    <ul>
                    <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>500 Database credits</li>
                    <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Use these credits in 30 days</li>
                    </ul>
                </div>
              </div>
          </div>
          <div className="col-md mb-4">
              <div className={`${styles['jobplan-box']}`}>
                <div className={`${styles['jobbox-top']}`}>
                    <h3>1 Month</h3>
                    <p>Ideal for enterprises</p>
                    <img src={dbIcon} className={`${styles['job-image']} img-fluid`}/>
                </div>
                <div className={`${styles['jobbox-cost']} my-3 p-2`}>
                <div className="d-flex flex-column align-items-start">
                      <div className="me-3">
                        <span className={`${styles['original-price']}`}>₹2800</span>
                      </div>
                      <div className="me-3">
                        <span className={`${styles['discounted-price']} pe-2`}>₹1689</span>
                        <span className={`${styles['discount']} border-start ps-2`}>10% Off</span>
                      </div>
                    </div>
                    <a href="#" className={`${styles['subs-btn']} btn w-100 mt-3`}> Subscribe Now</a>
                </div>
                <div className={`${styles['jobbox-list']} p-2`}>
                    <ul>
                      <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>1500 Database credits</li>
                      <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Use these credits in 30 days</li>
                    </ul>
                </div>
              </div>
          </div>
          <div className="col-md mb-4">
              <div className={`${styles['jobplan-box']}`}>
                <div className={`${styles['jobbox-top']}`}>
                    <h3>1 Month</h3>
                    <p>Ideal for Large Organisations</p>
                    <img src={dbIcon} className={`${styles['job-image']} img-fluid`}/>
                </div>
                <div className={`${styles['jobbox-cost']} my-3 p-2`}>
                <div className="d-flex flex-column align-items-start">
                      <div className="me-3">
                        <span className={`${styles['original-price']}`}>₹2800</span>
                      </div>
                      <div className="me-3">
                        <span className={`${styles['discounted-price']} pe-2`}>₹1689</span>
                        <span className={`${styles['discount']} border-start ps-2`}>10% Off</span>
                      </div>
                    </div>
                    <a href="#" className={`${styles['subs-btn']} btn w-100 mt-3`}> Subscribe Now</a>
                </div>
                <div className={`${styles['jobbox-list']} p-2`}>
                    <ul>
                      <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>10,000 Database credits</li>
                      <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/>Use these credits in 30 days</li>
                    </ul>
                </div>
              </div>
          </div>
          {/* Add other Job Post Plan cards here */}
        </div>
        )}

        {activeTab === "customPlan" && (
          <div className="row g-4 mb-3">
          {/* Custom Plan Section */}
          <div className="col-md-6">
            <div className={`${styles['custom-plan-section']} h-100`}>
              <div className={`${styles['bg-topnews']} p-3`}>
              <h3>Looking for a Custom Plan?</h3>
              <p>
                Unlock tailored solutions that meet your unique needs. Contact our sales team for
                customized features, support, and pricing that align perfectly with your requirements.
              </p>
              </div>
              <ul className={`${styles['list-topnews']} list-unstyled p-2`}>
                <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/> Dedicated Account Manager to ensure personalized support</li>
                <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/> Multiple Logins & Reports for team access and insights</li>
                <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/> Multimedia WhatsApp Invites for seamless communication</li>
                <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/> ATS Integration to streamline your hiring process</li>
                <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/> Company Branding & Promotion for enhanced visibility</li>
                <li><FontAwesomeIcon icon={faCheckCircle} className="text-info pe-2"/> Validity up to 360 Days with options for long-term planning</li>
              </ul>
             <div className="p-2">
             <a href="#" className={`${styles['subs-btn']} btn w-100`}>Contact Our Sales Team</a>
              </div>
              <div className="row my-3 p-2">
                <div className="col-md-6 d-flex justify-content-between flex-column">
                  <p className={`${styles['main-title']}`}>Mail Us:</p>
                  <p className={`${styles['main-paragraph']}`}>Send us an email with your requirements, and our sales team will respond as quickly as possible.</p>
                  <a href="mailto:sales@jobzShala.com" className={`${styles['jobnews-icon']}`}><FontAwesomeIcon icon={faEnvelope} className="pe-2"/>sales@jobzShala.com</a>
                </div>
                <div className="col-md-6 d-flex justify-content-between flex-column">
                  <p className={`${styles['main-title']}`}>Call Us:</p>
                  <p className={`${styles['main-paragraph']}`}>Give us a call, and our sales team will be happy to help you with your custom requirements.</p>
                  <a href="tel:+911234567890" className={`${styles['jobnews-icon']}`}><FontAwesomeIcon icon={faPhone} className="pe-2"/>+91-1234567890</a>
                </div>
              </div>
            </div>
          </div>
  
          {/* Contact Sales Form */}
          <div className="col-md-6">
            <div className="contact-sales-form bg-white rounded p-3 border">
              <div className="d-flex justify-content-between align-items-center">
              <h4 className={`${styles['main-title']}`}>Contact Sales</h4>
              <a href="#" className={`${styles['wt-btn']} btn`}><img src={Whatsapp} className="pe-2"/>Whatsapp</a>
              </div>
              <form>
                <div className="mb-3">
                  <label htmlFor="name" className={`${styles['formct-label']} form-label`}>Name</label>
                  <input type="text" className="form-control" id="name" placeholder="Enter your name" />
                </div>
                <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="email" className={`${styles['formct-label']} form-label`}>Email Address</label>
                  <input type="email" className="form-control" id="email" placeholder="Enter your email" />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="phone" className={`${styles['formct-label']} form-label`}>Phone Number</label>
                  <input type="tel" className="form-control" id="phone" placeholder="Enter your phone number" />
                </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="topic" className={`${styles['formct-label']} form-label`}>Topic</label>
                  <select className="form-select" id="topic">
                    <option defaultValue>Select a topic</option>
                    <option value="1">Database and Credits</option>
                    <option value="2">Custom Plans</option>
                    <option value="3">Support</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label htmlFor="subject" className={`${styles['formct-label']} form-label`}>Subject</label>
                  <input type="text" className="form-control" id="subject" placeholder="Enter subject" />
                </div>
                <div className="mb-3">
                  <label htmlFor="description" className={`${styles['formct-label']} form-label`}>Description</label>
                  <textarea className="form-control" id="description" rows="3" placeholder="Enter your message"></textarea>
                </div>
                <button type="submit" className={`${styles['subs-btn']} btn`}>Submit</button>
              </form>
            </div>
          </div>
        </div>
        )}
      </div>
              </div>
          </div>
          <div className="row">
              <div className="col-md-12">
              <div className="border rounded-3 shadow-sm">
                <div className={`${styles['jobbox-list']} p-2`}>
                  <ul>
                  <li>Please note that the amounts are exclusive of taxes. Taxes will be added as applicable.</li>
                  <li>Discount percentage have been rounded off to the nearest number.</li>
                  <li>Metro cities include Delhi/NCR (National Capital Region), Delhi, Gurgaon, Noida, Greater Noida, Ghaziabad, Faridabad, Mumbai and Mumbai Suburbs, Thane, Navi Mumbai, Pune, Chennai, Bengaluru/Bangalore, Kolkata, Hyderabad/Secunderabad, and Ahmedabad.</li>
                  </ul>
                </div>
            </div>
              </div>
          </div>
          <div className="row my-3">
            <div className="col-md-12">
                <div className="bg-light rounded-3 shadow-sm p-2 py-5 px-3">
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <h4 className={`${styles['main-titleone']}`}>Key Benefits</h4>
                            <p className={`${styles['main-para']}`}>Why Choose JobzShala Job Posting?</p>
                        </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-md-4">
                          <div className={`${styles['jobbx-box']}`}>
                              <img src={ClockIcon} alt="Days"/>
                              <h4 className="my-2">2 Minutes to Post</h4>
                              <p>Quick and easy to post job posting with a highly optimised job posting form.</p>
                          </div>
                      </div>
                      <div className="col-md-4">
                          <div className={`${styles['jobbx-box']}`}>
                              <img src={AudienceIcon} alt="Audience"/>
                              <h4 className="my-2">Attract Audience</h4>
                              <p>Reach to over 8.27 crore talented jobseekers.</p>
                          </div>
                      </div>
                      <div className="col-md-4">
                          <div className={`${styles['jobbx-box']}`}>
                              <img src={DaysIcon} alt="Clock"/>
                              <h4 className="my-2">30 days visibility</h4>
                              <p>Get quality applies guaranteed with 30 days visibility of your job ads.</p>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
          <div className="row my-4">
              <div className="col-md-12">
                  <h4 className={`${styles['acc-title']}`}>HAVE ANY QUESTIONS?</h4>
                  <p className={`${styles['acc-para']} mb-0`}>See how can you make the most out of this situation</p>
              </div>
              <div className="col-md-12 mt-2">
                  <div className="row">
                      <div className="col-md-4">
                        <div className={`${styles['accordion-ctm']} accordion h-100`} id="accordionExample">
                            <div className={`${styles['accordionctm-item']} accordion-item`}>
                              <h2 className={`${styles['accordionctm-header']} accordion-header`}>
                                <button className={`${styles['accordionctm-button']} accordion-button`} type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                How do I post a job o JobzShala?
                                </button>
                              </h2>
                              <div id="collapseOne" className={`${styles['accordionctm-collapse']} accordion-collapse collapse show`} data-bs-parent="#accordionExample">
                                <div className={`${styles['accordionctm-body']} accordion-body`}>
                                    <p>To post a job, log in to your Employer Login. Go to “Jobs & Responses" and click on the Job (classified or hot vacancy) link basis your subscription.</p>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                      <div className="col-md-4">
                      <div className={`${styles['accordion-ctm']} accordion h-100`} id="accordionExample">
                            <div className={`${styles['accordionctm-item']} accordion-item`}>
                              <h2 className={`${styles['accordionctm-header']} accordion-header`}>
                                <button className={`${styles['accordionctm-button']} accordion-button`} type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Difference between Hot Vacancy and Classified job posting?
                                </button>
                              </h2>
                              <div id="collapseOne" className={`${styles['accordionctm-collapse']} accordion-collapse collapse show`} data-bs-parent="#accordionExample">
                                <div className={`${styles['accordionctm-body']} accordion-body`}>
                                    <p>Classified Job Posting has limited job description (up to 250 characters) and absence of branding features for the Job. Hot Vacancy is the advanced Job Posting from JobzShala. It comes with No character limit for Job Description, exciting features like Job description (JD) import and JD suggestions(for select roles), Smart auto-fill of certain key fields, branding options and more.</p>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                      <div className="col-md-4">
                      <div className={`${styles['accordion-ctm']} accordion h-100`} id="accordionExample">
                            <div className={`${styles['accordionctm-item']} accordion-item`}>
                              <h2 className={`${styles['accordionctm-header']} accordion-header`}>
                                <button className={`${styles['accordionctm-button']} accordion-button`} type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                How can we promote a job posting?
                                </button>
                              </h2>
                              <div id="collapseOne" className={`${styles['accordionctm-collapse']} accordion-collapse collapse show`} data-bs-parent="#accordionExample">
                                <div className={`${styles['accordionctm-body']} accordion-body`}>
                                    <p>JobzShala offers value-added service of sharing your jobs on social media platform. You can also promote is as a Featured Job Listing, where your job gets displayed on top of the search results</p>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
    </div>
  )
}

export default Newsix